import type { Schemas } from '@seoai/api-types';

/**
 * §9 JSON zarfı. Tipler `packages/api-types` üzerinden openapi.json'dan ÜRETİLİR;
 * elle API tipi yazmak yasaktır (BACKEND.md §17).
 */
export type Envelope<TData> = {
  success: boolean;
  data?: TData;
  message?: string | null;
  error?: { code: string; message: string; details?: Record<string, unknown> | null };
  meta?: Schemas['EnvelopeMeta'];
};

/**
 * Backend hatası. `code` bir enum değeridir ({MODUL}.{KAYNAK}.{SEBEP}) —
 * arayüz mesaj metnine göre DEĞİL koda göre dallanır; metin locale'e göre değişir.
 *
 * `requestId` yanıttaki X-Request-Id: kullanıcının gördüğü hata ile sunucudaki
 * log kaydı ve Sentry olayı aynı kimlikle eşleşir (SEOAI-43/17/74).
 */
export class ApiError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status: number,
    readonly details: Record<string, unknown> | null = null,
    readonly requestId: string | null = null,
  ) {
    super(message);
    this.name = 'ApiError';
  }

  /** Alan bazlı doğrulama hataları (422) — `details` alan → mesajlar haritasıdır. */
  fieldErrors(): Record<string, string[]> {
    if (!this.details) return {};

    return Object.fromEntries(
      Object.entries(this.details).filter((entry): entry is [string, string[]] =>
        Array.isArray(entry[1]) && entry[1].every((m) => typeof m === 'string'),
      ),
    );
  }
}

/** Ağ/parse hatası da aynı tipe indirgenir: çağıran tek bir hata biçimi görür. */
export const NETWORK_ERROR_CODE = 'CLIENT.NETWORK.UNREACHABLE';
